import { createApi } from '@reduxjs/toolkit/query/react';
import Problem from 'models/ValueProposition/Problem';
import { axiosBaseQuery } from 'services/api';

const PROBLEM_TAG = 'Problem';

// API slice for Value Proposition / Problems
export const problemsApi = createApi({
  reducerPath: 'problemsApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/problems/',
  }),
  tagTypes: [PROBLEM_TAG],
  endpoints: builder => ({
    listProblems: builder.query({
      query: projectId => ({
        params: { project: projectId },
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(problem => new Problem(problem)) : [],
      providesTags: [PROBLEM_TAG],
    }),

    fetchProblem: builder.query({
      query: id => ({
        url: `${id}/`,
      }),
      transformResponse: response => new Problem(response),
      providesTags: [PROBLEM_TAG],
    }),

    createProblem: builder.mutation({
      query: problem => ({
        method: 'POST',
        data: problem,
      }),
      invalidatesTags: [PROBLEM_TAG],
      transformResponse: response => new Problem(response),
    }),

    updateProblem: builder.mutation({
      query: ({ problemId, ...problem }) => ({
        url: `${problemId}/`,
        method: 'PATCH',
        data: problem,
      }),
      invalidatesTags: [PROBLEM_TAG],
      transformResponse: response => new Problem(response),
    }),

    deleteProblem: builder.mutation({
      query: problemId => ({
        url: `${problemId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [PROBLEM_TAG],
    }),
  }),
});

export const {
  useListProblemsQuery,
  useFetchProblemQuery,
  useCreateProblemMutation,
  useUpdateProblemMutation,
  useDeleteProblemMutation,
} = problemsApi;
